import { render, staticRenderFns } from "./VisualSetting.vue?vue&type=template&id=9dbce0dc"
import script from "./VisualSetting.vue?vue&type=script&lang=js"
export * from "./VisualSetting.vue?vue&type=script&lang=js"
import style0 from "./VisualSetting.vue?vue&type=style&index=0&id=9dbce0dc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports